import { FC, PropsWithChildren, ReactNode } from 'react';
import { LinkProps, useMatchRoute } from '@tanstack/react-router';
import { cn } from '@/helpers/classnames';
import { NotificationDot } from '@/components/NotificationDot';
import Button from '../core/Button';

interface NavElementProps {
  to: LinkProps['to'];
  hiddenMobile?: boolean;
  title: ReactNode;
  icon: ReactNode;
  exactMatch?: boolean;
  notificationCount?: number;
  tutorialId?: string;
}

export const NavElement: FC<PropsWithChildren<NavElementProps>> = ({
  to,
  hiddenMobile = false,
  title,
  icon,
  exactMatch = false,
  notificationCount = 0,
  tutorialId,
}) => {
  const matchRoute = useMatchRoute();
  const isActive = !!matchRoute({ to, fuzzy: !exactMatch });

  return (
    <Button
      to={to}
      variant={isActive ? 'filled' : 'ghost'}
      className={cn(
        'relative min-h-max w-full justify-start px-1 py-2',
        hiddenMobile && 'hidden lg:flex',
      )}
      data-tutorial={tutorialId}
      startIcon={icon}
      aria-current={isActive ? 'page' : undefined}
    >
      {title}
      <div className="absolute right-0 animate-bounce">
        {notificationCount > 0 && <NotificationDot count={notificationCount} />}
      </div>
    </Button>
  );
};
